import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, toRefs } from 'vue';
import { User } from '@/models/User';
import useUser from '@/mixins/useUser';
import RecommendationApiWarning from '@/models/RecommendationApiWarning';
import { getRecommendationWarningModifier } from '@/views/recommendations/utils/recommendationWarningPresentation';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendWarningErrors',
  props: {
  resultMessageKey: {
    type: String,
    default: ''
  },
  user: {
    type: Object as PropType<User>,
    default: null
  },
  warning: {
    type: String as PropType<RecommendationApiWarning | null>,
    default: null
  }
},
  setup(__props) {

const props = __props;



const { user, warning } = toRefs(props);

const { tUserFallback: t } = useUser(user);
const warningClass = computed(() => {
  const modifier = getRecommendationWarningModifier(warning.value);
  return modifier ? `bc-recommend-warning-errors--${modifier}` : null;
});


return { __sfc: true,props, user, warning, t, warningClass }
}

})